import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, take, tap } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { settingsSelectors, State, UserType } from '@wam/shared';
import { isStaff } from './user.data';

@Injectable({
  providedIn: 'root',
})
export class StaffGuard {
  private store = inject<Store<State>>(Store);
  private router = inject(Router);

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(settingsSelectors.getUserType),
      map((userType: UserType) => this.isStaff(userType)),
      tap((isTeacher: boolean) => {
        if (!isTeacher) {
          this.router.navigate(['/']);
        }
      }),
      take(1),
    );
  }

  canLoad(): Observable<boolean> {
    return this.canActivate();
  }

  private isStaff(userType: UserType): boolean {
    return isStaff(userType);
  }
}
